'use client'

import { Text } from '@/components'
import { ClientRoutes, Config } from '@/config'
import Image from 'next/image'
import Link from 'next/link'
import { useLocale, useTranslations } from 'use-intl'

export default function NotFoundPage() {
  const t = useTranslations('404')
  const locale = useLocale() ?? Config.FALLBACK_LANG

  return (
    <div className="flex flex-row max-lg:flex-col max-lg:p-6 gap-12 max-2xl:w-full max-w-7xl mx-auto my-auto h-full items-center">
      <Image
        alt="not found"
        src="/assets/svg/not-found.svg"
        className="max-xl:mx-auto max-w-md"
        width={500}
        height={500}
      />
      <div className="text-white max-xl:text-center">
        <Text
          Element="h1"
          variant="heading4Xl"
          className="font-bold uppercase text-[160px] 2xl:text-[200px] m-0 p-0"
        >
          404
        </Text>
        <Text
          Element="p"
          variant="heading2Xl"
          className="w-full m-0 p-0 font-bold"
        >
          {t('desc')}
        </Text>
        <Text Element="p" variant="paragraphHuge" className="mt-3 2xl:mt-6">
          {t('headBack')}{' '}
          <Link
            href={`/${locale ?? Config.FALLBACK_LANG}${ClientRoutes.Home}`}
            className="text-glow-900"
          >
            {t('home')}
          </Link>
          , {t('or')}{' '}
          <Link
            href={`/${locale ?? Config.FALLBACK_LANG}${ClientRoutes.contact}`}
            className="text-glow-900"
          >
            {t('contact')}
          </Link>{' '}
          {t('ifNeedHelp')}
        </Text>
      </div>
    </div>
  )
}
